<template>
	<modal
			@close="$emit('close')"
			class="cancel-order-creation-modal choose-express-order"
	>
		<template slot="header">
      <div
          v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['express_UPSAuthorizationForm'])"></div>
        {{$t(`express_UPSAuthorizationForm.localization_value.value`)}}
      </div>
		</template>
		<template slot="body">
			<div class="cancel-order-creation__content"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['express_UPSAuthorizationFormTxt'])"></div>
				<p class="authorization-form mb-0" v-html="$t(`express_UPSAuthorizationFormTxt.localization_value.value`)">
				</p>
				<p class="authorization-form mt-0" v-html="$t(`express_UPSAuthorizationFormTxt2.localization_value.value`)">
				</p>

        <div class="custom-row">
          <div class="custom-col position-relative">
            <DropZone class="drop-zone-bg"
                      :parentFiles="File.data.files"
                      :multiple="false"
                      :maxCount="File.data.maxCountFiles - File.data.downloadFiles.length"
                      :maxSize="File.data.maxSizeFiles"
                      :accept="'application/pdf'"
                      @changeImg="changeFiles"
            />
            <div class="error-field ml-3" v-if="File.validation.files">
              {{$t('common_fileIsRequired.localization_value.value')}}
            </div>
          </div>
        </div>
      </div>
		</template>
		<template slot="footer">
			<div class="cancel-order-creation__btn">
        <div
            v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate([
              'common_close',
            ])"></div>
          <span
              class="site-link site-link--alt"
              @click="$emit('close')"
          >
          {{ $t('common_close.localization_value.value') }}
        </span>
        </div>


        <MainButton
            :value="$t('common_upload.localization_value.value')"
            class="buy-label__btn-i ml-3"
            @click.native="upload"
        />
			</div>
		</template>
	</modal>
</template>

<script>
import Modal from '../../../../commonModals/Modal.vue'
import MainButton from '../../../../UI/buttons/MainButton/MainButton.vue'
import DropZone from "@/components/coreComponents/DropZone/DropZone";
import {Files} from "@/components/globalModels/Files";

export default {
  name: "UPSAuthorizationFormPopup",
  components: {
    DropZone,
    Modal,
    MainButton,
  },

  data() {
    return {
      File: new Files({
        maxSizeFiles: 3,
        maxCountFiles: 1
      }),
    }
  },

  methods: {
    upload() {
      if(!this.File.firstValidation()) {
        return
      }

      let reader = new FormData();
      reader.append("file", this.File.getFiles()[0].file);
      reader.append('user_id', this.loadUserAuthorizedData?.user?.id)

      this.$store.dispatch('uploadUPSAuthorizationForm', reader).then(response => {
        switch (this.getResponseStatus(response)) {
            /**
             * Success
             */
          case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
            this.openNotify('success', 'common_notificationRecordChanged')
            this.$emit('success')
            break
          }
            /**
             * Validation Error
             */
          case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
            let errors = response.response.data.errors;
            this.notifyErrorHelper(errors)
            break
          }
            /**
             * Undefined Error
             */
          default: {
            this.openNotify('error', 'common_notificationUndefinedError')
          }
        }
      })

    },

    changeFiles(files, maxSizeError) {
      this.File.setFiles(files)

      this.File.setFilesMaxSizeError(maxSizeError)
    },
  },

}

</script>

<style lang="scss">
@import "../../../../../scss/mixins/mixins";

.authorization-form a {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-decoration-line: underline;
  color: #8F7A61;
  transition: 0.3s;
}

.cancel-order-creation{

  .modal-component__inner {
    max-width: 560px;
  }

  &__content{

  }

  &__btn{
    display: flex;
    align-items: center;

    @include for-680{
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &__btn-i{
    margin-right: 24px;

    @include for-680{
      margin-bottom: 15px;
    }

    &:last-child{
      margin-right: 0;
      margin-left: auto;
      @include for-680{
        margin: 0;

      }
    }
  }

  @include for-680{
    .save-drafts__btn-i{
      margin-bottom: 15px;
    }
  }

}
</style>
